import type { MyProfilePayload } from '../../../backend.d'
import { getJsonOrNullFromLocalStorage } from '../../../lib/localStorage'
import { Nullable } from '../../../typescript'

export const PROFILE_VALUE_LS_KEY = 'p0'

export default function getAuthProfileValueFromLocalStorage(): Nullable<MyProfilePayload> {
  return getJsonOrNullFromLocalStorage(PROFILE_VALUE_LS_KEY)
}
